import { flow, getParent, types } from 'mobx-state-tree';
import ENUMS from '../../constants/enums';

export const Notification = types
  .model('Notification', {
    description: types.string,
    id: types.number,
    linkType: types.number,
    listingId: types.maybe(types.string),
    timestamp: types.string,
    wasSeen: types.boolean,
  })
  .views(self => ({
    get browserHistory() {
      return getParent(self, 3).routingStore.browserHistory;
    },
    get toggleSettings() {
      return getParent(self, 3).settingsStore.toggleSettings;
    },
    get notificationsStore() {
      return getParent(self, 2);
    },
  }))
  .actions(self => ({
    handleClick() {
      switch (self.linkType) {
        case 0: {
          self.browserHistory.push(`/listings/single-item/${self.listingId}`);
          break;
        }
        case 1: {
          self.toggleSettings(ENUMS.SETTINGS_TABS.CONNECT);
          break;
        }
        case 2: {
          self.browserHistory.push(`/discover/main`);
          break;
        }
        default: {
          break;
        }
      }
    },
    markSeen: flow(function* markSeen() {
      if (self.wasSeen) {
        return;
      }
      const initialNotSeen = self.notificationsStore.totalNotSeen;
      try {
        self.wasSeen = true;
        self.notificationsStore.setTotalNotSeen(initialNotSeen - 1);
        yield self.notificationsStore.markSeenNotification(self.id);
      } catch (e) {
        self.wasSeen = false;
        self.notificationsStore.setTotalNotSeen(initialNotSeen);
        console.error(e);
      }
    }),
    setSeen() {
      self.wasSeen = true;
    },
  }));
